import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  readonly currentLabel = signal<string | null>(null);

  readonly currentPageMissing = signal(false);

  readonly currentUrl = signal<string | null>(null);

  markCurrentPageMissing(label: string): void {
    this.currentLabel.set(label);
    this.currentPageMissing.set(true);
    this.currentUrl.set(null);
  }

  reset(): void {
    this.currentLabel.set(null);
    this.currentPageMissing.set(false);
    this.currentUrl.set(null);
  }

  setCurrentPage(label: string | null, url: string | null): void {
    this.currentLabel.set(label);
    this.currentPageMissing.set(false);
    this.currentUrl.set(url);
  }
}
